/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Media_Uploaded_SuccessInputs */

const en_toast_media_uploaded_success = /** @type {(inputs: Toast_Media_Uploaded_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media uploaded successfully`)
};

const nl_toast_media_uploaded_success = /** @type {(inputs: Toast_Media_Uploaded_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media succesvol geüpload`)
};

/**
* | output |
* | --- |
* | "Media uploaded successfully" |
*
* @param {Toast_Media_Uploaded_SuccessInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_media_uploaded_success = /** @type {((inputs?: Toast_Media_Uploaded_SuccessInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Media_Uploaded_SuccessInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_media_uploaded_success(inputs)
	return en_toast_media_uploaded_success(inputs)
});